import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"

import {useBlogCategoryData} from "../Blog/utils"
import BlogCard from "../Blog/BlogCard"
import {SectionWrapper, Row, Col} from "@styles/grid"

function FeaturedBlogSection(props) {
	const [blogList, setBlogList] = useState([])

	const [, , , blogs] = useBlogCategoryData()

	useEffect(() => {
		if (blogList.length === 0) {
			// Filter selected blogs
			const blogLinks = props.blogs.map(blog => blog.link)

			const filteredBlogs = blogs.filter(blog => {
				return blogLinks.some(link => link.includes(blog.slug))
			})

			setBlogList(filteredBlogs)
		}
	}, [blogList, blogs])

	return (
		<SectionWrapper
			bgPrimary={props.bgPrimary}
			containerProps={{style: {marginTop: "60px", marginBottom: "60px"}}}>
			<Row>
				{blogList.map(blog => (
					<Col className='col-md-6 col-xl-4 mgn-b-30'>
						<BlogCard {...blog} />
					</Col>
				))}
			</Row>
		</SectionWrapper>
	)
}

export default FeaturedBlogSection

FeaturedBlogSection.propTypes = {
	blogs: PropTypes.array.isRequired,
	bgPrimary: PropTypes.bool
}
